import { OriginConnectionPosition, OverlayConnectionPosition } from '@angular/cdk/overlay';
import { Directive, ElementRef, Input, OnInit } from '@angular/core';
import { Store } from '@ngxs/store';
import _ from 'lodash';
import { AppModulesType } from '../_shared/enums/appModulesType.enum';
import { WizardListElement } from '../_shared/model/wizardListElement.model';
import { ActiveModulesService } from './../_shared/services/activeModules.service';
import { OverlayService } from './../_shared/services/overlay.service';
import { BaseState } from './../_shared/state/base/base.state';

@Directive({
    selector: '[appOverlayContent]',
})
export class OverlayContentDirective implements OnInit {
    public isOnboardingActive = false;
    constructor(
        public contentInjectedIntoPopup: ElementRef,
        private overlayService: OverlayService,
        private store: Store,
        private am: ActiveModulesService,
    ) {
        //skrij <div> iz GUI-ja
        _.set(this.contentInjectedIntoPopup, 'nativeElement.style.display', 'none');
    }
    ngOnInit() {
        this.isOnboardingActive = this.am?.isAM(AppModulesType.ONBOARDING_WIZARD);
        if (!_.isNil(this.overlayId) && this.isOnboardingActive) {
            //check state, če je wizard s tem ID že poklukan, če ni -> open overlay
            if (
                this.checkOverlayId(
                    _.get(
                        this.store
                            .selectSnapshot(BaseState.GetOnboardingWizardSettings)
                            ?.find((wizard: WizardListElement) => wizard.id === this.overlayId),
                        'completed',
                        undefined,
                    ),
                )
            ) {
                this.tryOpenOverlay();
            }
        }
    }

    //odpri popup samo enkrat
    // TODO Ignored with eslint-interactive on 2023-11-10
    // eslint-disable-next-line @typescript-eslint/member-ordering
    public overlayWasOpened = false;

    //podatki o elementu, na katerega lahko "pripneš" popup za boljšo pozicijo (optional)
    // TODO Ignored with eslint-interactive on 2023-11-10
    // eslint-disable-next-line @typescript-eslint/member-ordering
    @Input() targetRefData?: {
        targetRef: ElementRef;
        originXY?: OriginConnectionPosition; //{ originX: 'start', originY: 'top' }
        overlayXY?: OverlayConnectionPosition; //{ overlayX: 'start', overlayY: 'top' }
    };

    //globalPositionConfig --> pozicija, če nimaš targetRef definiran. primer: [globalPositionConfig]=['left100px','top200px'] -> popup ima levo odmika 100px, top odmika 200px (optional)
    // TODO Ignored with eslint-interactive on 2023-11-10
    // eslint-disable-next-line @typescript-eslint/member-ordering
    @Input() globalPositionConfig?: string[];

    //show OK button in overlay. Če je = true, se overlay ugasne s klikom na ta gumb, če je = false, se ugasne ko klikneš izven overlaya
    // TODO Ignored with eslint-interactive on 2023-11-10
    // eslint-disable-next-line @typescript-eslint/member-ordering
    @Input()
    showButton?: boolean = true;

    //overlayId, za lažje povezovanje overlaya in API klicev
    // TODO Ignored with eslint-interactive on 2023-11-10
    // eslint-disable-next-line @typescript-eslint/member-ordering
    @Input()
    overlayId = -99999;

    //simpleOverlaySettings -> odpre simple overlay, ki ima samo naslov in vnešen tekst
    // TODO Ignored with eslint-interactive on 2023-11-10
    // eslint-disable-next-line @typescript-eslint/member-ordering
    @Input()
    simpleOverlaySettings?: { title: string; textContent: string };

    //odpri overlay samo enkrat
    public tryOpenOverlay() {
        if (!this.overlayWasOpened) {
            this.overlayWasOpened = true;
            this.overlayService.open(
                this.contentInjectedIntoPopup,
                this.showButton,
                this.overlayId,
                this.simpleOverlaySettings,
                this.targetRefData,
                this.globalPositionConfig,
            );
        }
    }

    //pogoj, kdaj prikažemo popup --> v direktivi ga definiraj zadnjega
    @Input()
    set openOverlay(condition: boolean) {
        if (condition) this.tryOpenOverlay();
    }

    //kdaj pokažeš overlay
    public checkOverlayId(completed: boolean): boolean {
        if (completed == true || completed == undefined) {
            return false;
        }
        return true;
    }
}
